<template>
    <!--    头部组件-->
    <div class="headerTop">
        <!--        具体内容-->
        <div class="content mainBox">
            <!--            右侧图片-->
            <div class="headerImg" style='width:160px;height:56px;'>
                <el-image style="width:160px;height:56px;" :src="imgLogoUrl" fit="scale-down"></el-image>
            </div>
            <!--            中间导航-->
            <ul>
                <li v-for="(item,index) in navTextArr"
                    :key="index"
                    :class="{navActive:item.name===$route.name}"
                    @click="navClick(index)"
                >
                    {{item.title}}
                </li>
            </ul>
            <!-- 字母数字中文 -->
            <el-input placeholder="请输入关键字" v-model.trim="inputText" class="input-with-search" clearable @input="inputText=inputText.replace(/[^(a-zA-Z0-9\u4e00-\u9fa5)]/g,'')"  @keyup.enter.native="searchClick">
                <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
            </el-input>
            <!--            左侧登录/注册-->
            <!--            未登录时-显示-->
            <div class="loginRegister" v-if="!username">
                <!-- 弹窗-3个账号类型 -->
                <a @click="loginAction">登录</a>
                <!-- 不跳转外链汇办事的登录页面 -->
                <!-- <a :href="`${$store.state.backHref}#/login?origin=1`">登录</a> -->
                <!-- 不要注册按钮了 -->
                <!-- <a :href="`${$store.state.backHref}#/login?origin=1`">登录</a>|<a :href="`${$store.state.backHref}#/regist?type=0&origin=1`">注册</a> -->
            </div>
            <!--            登录后-显示-用户信息&操作  -->
            <el-dropdown v-else @visible-change="hoverAction" class="loginRightDown">
                <span class="el-dropdown-link">
                    {{ username }}
                    <i  :class="isHover?'el-icon-arrow-up el-icon--right':'el-icon-arrow-down el-icon--right'"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="loginDropdown">
                    <el-dropdown-item><i class="el-icon-setting"></i><a :href="`${$store.state.backHref}#/?refresh_token=${refresh_token}&x_token=${x_token}&origin=${key}&parkId=${parkId}`">管理中心</a></el-dropdown-item>
                    <el-dropdown-item><i class="el-icon-user"></i><a :href="`${$store.state.backHref}#/accountInfo?refresh_token=${refresh_token}&x_token=${x_token}&origin=${key}&parkId=${parkId}`">账号信息</a></el-dropdown-item>
                    <el-dropdown-item><i class="el-icon-switch-button"></i><a href="javascript:void(0)" @click="layout">退出登录</a></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    export default {
        name: "lp-Header",
        data(){
            return{
                // logo图片
                logoImg:require('../../assets/images/logo.png'),
                // 顶部导航-默认激活第一个按钮
                navActive:0,
                navTextArr:[
                    {title:'首页',name:'Home'},
                    {title:'资讯',name:'InforList'},
                    {title:'政策解读',name:'Policy'},
                    {title:'申报通知',name:'Declaration'},
                    {title:'政银企互动',name:'GBCInteraction'},
                    {title:'高新风采',name:'NewStyle'},
                    {title:'第三方服务',name:'ThirdParty'},
                    // {title:'创新服务券',name:'Innovative'}//隐藏
                    ],
                isHover:false,//右上角是否鼠标悬浮
                inputText:'',//搜索
                imgLogoUrl:''
            }
        },
        created() {
            const { parkId }=this.$store.state;
            if(parkId==4) this.navTextArr[5].title='新城风采'
            this.getLogoList();
        },
        activated(){
           
            this.getLogoList();
        },
        computed: {
            parkId(){
                return this.$store.state.parkId;
            },
            username(){
                return this.$store.state.username;
            },
            refresh_token(){
                return this.$store.state.refreshToken;
            },
            x_token(){
                return this.$store.state.token;
            },
            key(){
                return this.$store.state.hostKey;
            }
        },
        methods:{
            //获取parkId
                async getLogoList(){
                    console.log(this.$route,'域名');
                        //获取logo信息
                        let res = await this.$Apis.getWebLogos({parkId: this.parkId});
                        const {code,data}=res;
                        if(code == 1) {
                            if(data&&data.length>0){
                                data.forEach((item)=>{
                                    if(item.logoType==1){
                                        this.imgLogoUrl=item.image;
                                    }
                                })
                            }
                        }
                    },
            //搜索
            searchClick(){
                if(this.inputText&&this.inputText.length>0){
                    let routerText=this.inputText;
                    this.inputText='';//置空
                    this.$store.commit('SET_ALLSEARCH', routerText);
                    // console.log(this.$route,this.$router);
                    // if(this.$route&&this.$route.name=='HomeSearch'){
                    //     // 刷新当前路由
                    //      this.$router.replace({path:'/refresh'})
                    // }else{
                         this.$router.push({path:"/homeSearch"});
                    // }

                }else{
                     this.$message({
                    showClose: true,
                    message: '请输入关键字',
                    type: 'warning'
                    });
                }

            },
            // 导航点击-响应方法
            navClick(index){
                this.navActive=index
                var path=this.navTextArr[index]
                console.log(this.navTextArr[index],index)
                this.$router.push({
                    name:path.name,
                    params:0
                });
            },
            //退出登录
            layout(){ 
                this.$confirm('确定退出?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    // type: 'warning'
                    }).then(() => {
                        localStorage.clear();
                        this.$store.commit('INITE_STATE');
                         let url = window.location.href;
                        window.location.replace(url) ;
                });
                // this.$router.push({path:'/'})
            },
            // 点击登录-显示登录弹窗-3个账号类型
            loginAction(){
                 
                // 显示登录弹窗
                this.$store.commit('SET_LOGIN',true);
                // 顶部-右上角-显示3种账号的登录方式
                this.$store.commit('SET_ONLYENTERPRISELOGIN',false);
                 
                //跳转当前官网页面-登录
                // type=0 默认3种账号登录，type=1,仅企业账户登录 
                // this.$router.push({path: '/login', query: {type: 0}});
            },
            hoverAction(isHover){
                this.isHover=isHover
                console.log(isHover)
            }
        }
    }
</script>

<style lang="less" scoped>
    .headerTop{
        background-color: @backDefaultColor;
        height: @headerHeight;
        width: 100%;
        /*头部-内容*/
        .content{
            width: 1300px;
            height: 100%;
            display: flex;
            justify-content: space-between;
            /*align-content: space-between;*/
            align-items: center;
            /*logo*/
            .headerImg{
                // width: 186px;
                // height: 46px;
                // background: url("../../assets/images/logo.png") no-repeat;
                // background-size: cover;
            }
            /*导航*/
            ul{
                width: 720px;
                height: 100%;
                display: flex;
                li{
                    width: 120px;
                    height: 100%;
                    line-height: 80px;
                    text-align: center;
                    color: @fontDefaultColor;
                    font-size: @fontMediumSize;
                    cursor: pointer;
                }
                /*选中样式*/
                li:hover,.navActive{
                    font-weight: bold;
                    background-color: @backBlueColor;
                    color: @backDefaultColor;
                }
            }
            /*右侧登录/注册*/
            .loginRegister{
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: @fontDefaultSize;
                a{
                    height: 30px;
                    width: 60px;
                    text-decoration: none;
                    font-family: MicrosoftYaHeiUI;
                    font-size: 14px;
                    color: #333333;
                    border: 1px solid #c3c6cb;
                    border-radius: 4px;
                    text-align: center;
                    line-height: 30px;
                }
                a:hover{
                    color: @hoverDefaultColor;
                    border: 1px solid #1890FF;
                    cursor: pointer;
                }
            }
            /*处理-右侧-用户信息显示的样式*/
            .el-dropdown{
                // width: 200px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                height: @headerHeight;
                background: #fff!important;
                font-family: MicrosoftYaHeiUI;
                font-size: 14px;
                color: #333333;
            }
            //搜索
            .input-with-search {
                width: 224px;
                height: 36px!important;
                margin: 0 20px;
                
                /deep/ .el-input__inner{
                    background-color: #F6F6F6;
                    border: 1px solid #EBEBEB;
                   height: 36px!important;
                }
               /deep/ .el-input-group__append {
                    background-color:#1063B9 ;
                    opacity:.55;
                    // height: 30px!important;
                    .el-icon-search{
                       color:#fff ;
                    }
                }
                 /deep/ .el-input-group__append:hover {
                    opacity:1;
                }
            }
        }
        
    }
    
</style>


// WEBPACK FOOTER //
// src/components/header/index.vue